import api from './api.js';

export const indiceService = {
  search: (query) => api.get(`/indices?search=${query}`),
  show: (id) => api.get(`/indices/${id}`),
};
